/*eslint-disable */
import React, { Component } from "react";
import ShipmentHeader from "../../components/vendor-login/ordersComponent/shipmentHeader";
import { Image } from "semantic-ui-react";
import AllotedGridView from "../../components/vendor-login/ordersComponent/AllotedGridView";
import { readAllotedOrdersDispatcher } from "../../redux/actions/shipmentAction";
import { updatePagination, readPagination } from "../../redux/actions/paginationAction";
import { connect } from "react-redux";
import ReadAxios from "../../components/axiosComponent/read";
import AsyncAgGridTable from "../../components/common/asyncAgGridTable";
import { translate } from "react-i18next";
import moment from "moment";
import { isEmpty } from "lodash";
import Orders from "../../components/vendor-login/ordersComponent/orders";
import {FEATURES,DATE_FORMATS} from '../../utils/constant'
import {order_allotment_status} from '../../utils/constant'

Object.defineProperty(Array.prototype, "chunq", {
  value: function (chunqSize) {
    var R = [];
    for (var i = 0; i < this.length; i += chunqSize)
      R.push(this.slice(i, i + chunqSize));
    return R;
  },
});
class Alloted_Orders extends Component {

  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      grid: FEATURES.alloted_orders_grid_state ? true : (this.props?.location?.state?.gridview ? true :false),
      loadingData: true,
      prevProps: [],
      // ag-grid async call
      locales: props.locales.local,
      rowData: [],
      paginationCallbackData: [],
      chunkedRowData: [],
      currentPageData: [],
      currentPageNumber: -1,
      agGridPageSize: 10,
      componentRenderKey: 0,
      pageNoOn: this.props.paginationIndex.allocated_order_card_page || 1,
      pageNoOnGrid: this.props.paginationIndex.allocated_order_grid_page || 1
    };
  }

  async componentDidMount() {
this.props.history.push({state:{gridview:false} });
    if (this.props?.paginationIndex?.allocated_order_card_page)
      this.setState({ pageNoOn: this.props.paginationIndex.allocated_order_card_page })
    if (this.props?.paginationIndex?.allocated_order_grid_page)
      this.setState({ pageNoOnGrid: this.props.paginationIndex.allocated_order_grid_page })
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.locales == nextProps.locales.local) {
      this.setState({ locales: nextProps.locales.local }, () =>
        this.agGridAsyncCalls(nextProps)
      );
    }
  }

  componentWillUnmount() {
    if (!window.location.href.includes('alloted-order-details')) {
      this.props.updatePagination(1, 'GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE')
      this.props.updatePagination(1, 'GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE')
    }
  }

  updatePaginationPage = (pageNo) => {
    this.props.updatePagination(pageNo, 'GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE')
    if (this.props?.paginationIndex?.allocated_order_card_page)
      this.setState({ pageNoOn: this.props.paginationIndex.allocated_order_card_page })
  }

  updateGridPaginationPage = (pageNo) => {
    this.props.updatePagination(pageNo, 'GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE')
    if (this.props?.paginationIndex?.allocated_order_grid_page)
      this.setState({ pageNoOn: this.props.paginationIndex.allocated_order_grid_page })
  }

  agGridAsyncCalls(nextProps) {
    //console.log(nextProps);
    if (
      nextProps.shipment &&
      JSON.stringify(this.state.rowData) !==
      JSON.stringify(nextProps.shipment.read)
    ) {
      const { componentRenderKey } = this.state;
      this.setState(
        {
          loadingData: false,
          prevProps: nextProps.shipment.read.chunk(5),
          rowData: nextProps.shipment.read,
          componentRenderKey: componentRenderKey + 1,
        },
        () => console.log("set state 115")
      );
    } else {
      this.setState(
        {
          loadingData: false,
          rowData: [],
          prevProps: [],
        },
        // () => console.log("set loading false")
      );
    }
  }

  OnpaginationChangeCallback = (event) => {
    let apiDataJSON = [];
    const agGridPageSize = event.api.paginationProxy.pageSize;
    const agGridCurrentPage = event.api.paginationProxy.currentPage;
    const agGridPageTotalData = this.state.rowData;
    const agGridPageinationData = agGridPageTotalData.chunk(agGridPageSize);
    const agGridCurrentPageData = agGridPageinationData[agGridCurrentPage];
    // prepare data to make api call and merge it with row Data
    apiDataJSON = agGridCurrentPageData.map((item) => {
      return {
        route_id: item.route_id,
        vehicle_id: item.proposed_vehicle_type,
      };
    });
    let agGridCurrentPageFetch = [];
    apiDataJSON.map(async (item, index) => {
      let routeManager =
        (await ReadAxios({ url: `routeManager/${item.route_id}` })) || [];
      let vehicleTypeManager = []
      // (await ReadAxios({ url: `vehicleTypeMaster/${item.vehicle_id}` })) || [];
      routeManager = isEmpty(routeManager) ? [] : routeManager.data.resultSet;
      vehicleTypeManager = isEmpty(vehicleTypeManager)
        ? []
        : vehicleTypeManager.data.resultSet;
      agGridCurrentPageFetch.push({
        source: routeManager[0].checkPointName,
        destination: routeManager[routeManager.length - 1].checkPointName,
        vehicle_type: vehicleTypeManager[0]
          ? vehicleTypeManager[0].vehicleType
          : "",
      });

      if (
        agGridCurrentPageFetch.length == agGridCurrentPageData.length &&
        JSON.stringify(this.state.paginationCallbackData) !=
        JSON.stringify(agGridCurrentPageFetch)
      ) {
        const { componentRenderKey } = this.state;
        this.setState(
          {
            paginationCallbackData: agGridCurrentPageFetch,
            chunkedRowData: agGridPageinationData,
            currentPageData: agGridCurrentPageData,
            currentPageNumber: agGridCurrentPage,
            agGridPageSize: agGridPageSize,
            componentRenderKey: componentRenderKey + 1,
          },
          () => {
            //console.log("set state 161");
            this.mergeTheCallbackDataWithRowData();
          }
        );
      }
    });
  };

  mergeTheCallbackDataWithRowData = () => {
    let currentPageNumber = this.state.currentPageNumber;
    let pageSize = this.state.agGridPageSize;
    let rowData = this.state.rowData;
    let currnetFetchData = this.state.paginationCallbackData;
    let currentPageData = this.state.currentPageData;
    let tempRowData = currentPageData.map((item, index) => {
      return Object.assign({}, item, currnetFetchData[index]);
    });
    let startIndex = currentPageNumber * pageSize;
    rowData.splice(startIndex, pageSize, ...tempRowData);
    const { componentRenderKey } = this.state;
    this.setState(
      {
        rowData: rowData,
        componentRenderKey: componentRenderKey + 1,
      },
      //() => console.log("set state 147")
    );
  };

  handleGridView = () => {
    const { componentRenderKey } = this.state;
    this.setState(
      {
        loadingData: false,
        grid: !this.state.grid,
        componentRenderKey: componentRenderKey + 1,
      },
      //() => console.log("set state 185")
    );
  };

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-shipment", {
      ...rowData,
      title: "Edit Shipment",
    });
  };

  onRowDelete = () => {
    this.props.history.push("/shipment");
    this.props.history.go();
  };

  redirectToShipmentDetail = (item) => {
    let shipment = item[0];
    this.props.history.push({
      pathname: "/shipment-details",
      state: { item: { ...shipment } },
      search: `?shipmentId=${shipment.vendor_shipment_id}`,
    });
  };

  render() {
    const { t } = this.props;
    const { grid, rowData, componentRenderKey } = this.state;
    const columnDefs = [
      {
        headerName: t("table_view.reference_no") || "Refrence No",
        field: "order_reference_no",
        sortable: true,
        filter: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: (params)=>{
          if(params.data.allotment_status.allotment_code == order_allotment_status.waitingForVehicle){
            return true
          }else{
            return false
          }
        },
        cellClass: params => {
          return (params.data.allotment_status.allotment_code == order_allotment_status.waitingForVehicle) ?  'padding-left-0' : 'padding-left-40' ;
        },
        tooltipField: "order_reference_no",
        enableRowGroup: true,
        enablePivot: true,
        width: 200,
      },
      {
        headerName: t("table_view.status") || "Status",
        field: "allotment_text", // vehicle_type
        sortable: true,
        cellRenderer: "allotment",
        filter: true,
      },
      {
        headerName: t("table_view.source") || "Source",
        field: "source", // source
        cellRenderer: "sourcerender",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.destination") || "Destination",
        field: "destination", // destination
        cellRenderer: "destinationrender",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.dispatch_location") || "Dispatch Location",
        field: "dispatch_locations_absolute",
        sortable: true,
        filter: true,
        hide: FEATURES.dipatch_loc_hide_in_alloted_orders ? false : true
      },
      {
        headerName: t("table_view.bl_no") || "Bl Number",
        field: "bl_numbers", // destination
        // cellRenderer: "blrender",
        tooltipField: "bl_numbers",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.container_number") || "Container Number",
        field: "container_no",
        tooltipField: "container_no",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.vehicle_type") || "Vehicle Type",
        field: "vehicle_type", // vehicle_type
        sortable: true,
        cellRenderer: "vehicletyperenderer",
        filter: true,
      },
      {
        headerName: t("table_view.gross_weight") || "Weight (in kgs)",
        field: "gross_weight",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.remarks") || "Remarks",
        field: "remarks",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.expected_pickup_date") || "Expected Pickup Date",
        field: "expected_pickup_date",
        sortable: true,
        filter: true,
        valueFormatter: function (params) {
          if (params.value)
            return moment(params.value, DATE_FORMATS.YYYYMMDDHHmmss).format(DATE_FORMATS.DDMMYYYYHHmmss);
          else
            return "NA"
        },
      },
      {
        headerName: t("table_view.expected_delivery_date") || "Expected Delivery Date",
        field: "expected_delivery_date",
        sortable: true,
        filter: true,
        valueFormatter: function (params) {
          if (params.value) {
            console.log("PArams", params.value)
            return moment(params.value, DATE_FORMATS.YYYYMMDDHHmmss).format(DATE_FORMATS.DDMMYYYYHHmmss);
          } else {
            return "NA"
          }
        },
      },
      {
        headerName: t("table_view.movement_type") || "Moment Type",
        field: "shipment.movement_type",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_view.required_on") || "Required On",
        field: "shipment.required_on",
        sortable: true,
        filter: true,
        valueFormatter: function (params) {
          return moment(params.value).format(DATE_FORMATS.DD_MM_yyyy);
        },
      }
    ];

    return (
      <React.Fragment>
        {/* <ShipmentHeader
          LinkName="/add-shipment"
          title={t("orders.alloted_title") || "Alloted Orders"}
          toggleView={this.handleGridView}
          // handleSearch={this.handleChange}
          toggle={!this.state.grid}
        /> */}

        {grid ? (

          <Orders {...this.props} columnDefs={columnDefs} title={t("orders.alloted_title") || "Alloted Orders"} toggleView={this.handleGridView} order_status="alloted" toggle={!this.state.grid} allotedOrdersStatusShow={true}
            updateGridPaginationPage={this.updateGridPaginationPage}
            pageNoOn={this.state.pageNoOnGrid}
            pageNoLast={this.props?.paginationIndex?.allocated_order_grid_page}
            allotedOrder = {true}
          />
        ) : (<AllotedGridView
          updatePaginationPage={this.updatePaginationPage}
          pageNoOn={this.state.pageNoOn}
          pageNoLast={this.props?.paginationIndex?.allocated_order_card_page}
          toggleView={this.handleGridView}
          toggle={!this.state.grid}
          shipmentData={this.state.prevProps}
          isLoading={this.state.loadingData}
          allotedOrdersStatusShow={true}
          baseURL={'allocatedOrdersImport'}
        />
        )}

        {rowData.length > 0 ? (
          <div
            className="life-cycle w3-white"
            style={{ position: "relative", marginTop: "2em" }}
          >
            {/* <Image
              className="ml-5 pl-5 pt-3 pb-3"
              src="assets/img/ta_life.png"
            /> */}
          </div>
        ) : ""
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ shipment, locales, paginationIndex }) => {
  return {
    shipment,
    locales,
    paginationIndex
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updatePagination: (...data) => dispatch(updatePagination(data)),
    readPagination: () => dispatch(readPagination()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("orders")(Alloted_Orders));
